import { render, staticRenderFns } from "./wedding.vue?vue&type=template&id=4cab2418"
import script from "./wedding.vue?vue&type=script&lang=js"
export * from "./wedding.vue?vue&type=script&lang=js"
import style0 from "./wedding.vue?vue&type=style&index=0&id=4cab2418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports